module.exports = __webpack_public_path__ + "img/21.153f4dd1.png";